/**
 * Shared DOM enhancement: merges former accessibility-fixes observers
 * with lightweight post-load fixes. Swym observers are intentionally excluded.
 */
(function () {
  'use strict';

  var IDLE_DISCONNECT_MS = 20000;
  var imageSelector = '.snptlinked-item-ico img:not([alt]), .snptlinked-item-ico img[alt=""]';
  var observer = null;
  var idleTimer = null;

  function addMissingAltText(root) {
    if (!(root instanceof Element) && root !== document) return;

    var images = [];
    if (root instanceof Element && root.matches(imageSelector)) {
      images.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll(imageSelector).forEach(function (image) {
        images.push(image);
      });
    }
    images.forEach(function (image) {
      image.setAttribute('alt', 'Instagram Shop Image');
    });
  }

  function fixMenuItems(root) {
    if (!(root instanceof Element) && root !== document) return 0;

    var menuItems = [];
    if (root instanceof Element && root.matches('.tmenu_item')) {
      menuItems.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.tmenu_item').forEach(function (item) {
        menuItems.push(item);
      });
    }

    menuItems.forEach(function (item) {
      if (item.tagName === 'LI' && item.parentElement && !['UL', 'OL'].includes(item.parentElement.tagName)) {
        var wrapper = document.createElement('ul');
        wrapper.className = 'tmenu_submenu_list';
        item.parentNode.insertBefore(wrapper, item);
        wrapper.appendChild(item);
      }
    });

    return menuItems.length;
  }

  function enhanceNode(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    addMissingAltText(node);
    fixMenuItems(node);
  }

  function scheduleDisconnect() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }, IDLE_DISCONNECT_MS);
  }

  function revealDeferredWidgetsOnInteraction() {
    // Match speed-optimizer: one unlock path for chat / Join us / overlays.
    var events = ['pointerdown', 'keydown', 'touchstart', 'click'];
    var UI_IDLE_MS = 10000;
    var idleTimer = 0;

    function reveal() {
      if (document.body) {
        document.body.classList.add('rep-chat-ready');
        document.body.classList.add('deferred-widgets-ready');
      }
      if (idleTimer) clearTimeout(idleTimer);
      for (var i = 0; i < events.length; i++) {
        window.removeEventListener(events[i], reveal, { capture: true });
      }
    }

    for (var i = 0; i < events.length; i++) {
      window.addEventListener(events[i], reveal, { capture: true, passive: true });
    }
    idleTimer = setTimeout(reveal, UI_IDLE_MS);
  }

  function start() {
    addMissingAltText(document);
    fixMenuItems(document);
    revealDeferredWidgetsOnInteraction();

    if (!document.body) return;

    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          enhanceNode(nodes[j]);
        }
      }
      scheduleDisconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    scheduleDisconnect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
